import { render, staticRenderFns } from "./FunFactsSection.vue?vue&type=template&id=0cd0e34b&"
import script from "./FunFactsSection.vue?vue&type=script&lang=js&"
export * from "./FunFactsSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports